import { IconButton, Tooltip } from "@material-ui/core";
import React from "react";
import {
  ButtonConfirm,
  CloseModal,
  ContentModal,
  TextModal,
} from "./ModalShowErrors.styled";
import ErrorOutlinedIcon from "@material-ui/icons/ErrorOutlined";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import PortalModal from "../../Portals";

const ModalShowErrors = ({ open, setOpen }) => {
  return (
    <PortalModal>
      <ContentModal>
        <CloseModal>
          <Tooltip title="close">
            <IconButton onClick={() => setOpen(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModal>
        <TextModal>
          <ErrorOutlinedIcon />
          <p>{open.message}</p>
        </TextModal>
        <div style={{ display: "inline-flex", margin: "auto", width: "100%" }}>
          <ButtonConfirm onClick={() => setOpen({})}>close</ButtonConfirm>
        </div>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalShowErrors;
